import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, Navigate } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { HeaderProfile, ProfileMenu } from '../../components/profile-prive'

import { WEBROOT, APP_NAME } from '../../constants/general'

import { Context } from '../../class/Context'

import Func from '../../class/Func'

import Paiements_Class from '../../class/Paiements_Class'

function PasserOwner() {

    const navigate = useNavigate();

    const context = useContext(Context)

    const [flash, setFlash] = useState('')

    const [data, setData] = useState(false)

    const [loading, setLoading] = useState(false)

    const userPaiements = async () => {

        let results = await Paiements_Class.paiements()

        if (results.success) {

            if (results.UserCategory == 'OWNER' && results.UserStatus == 'ACTIVE') {

                navigate('/mon-profile/porte-monnaie')

                return false
                
            }

            if (results.UserCategory == 'OWNER' && results.UserStatus == 'PENDING_USER_ACTION') {

                redirectFunc(results.RedirectUrl)

                return false

            } else {

                setData(results.data)

            }

            setData(results.data)

        } else {

            setFlash({ message: results.message, type: "error" })

        }

        window.scrollTo(0, 0)

    }

    const sendData = async (e) => {

        e.preventDefault()

        setLoading(true)

        let inputs = e.target

        let date = inputs.date.value

        let results = await Paiements_Class.post('passer-owner', { date })

        if (results.success) {

            redirectFunc(results.RedirectUrl)

            setFlash({ message: results.message, type: "succes" })

        } else {

            setFlash({ message: results.message, type: "error" })

        }

        window.scrollTo(0, 0)

        setLoading(false)

    }

    const redirectFunc = (RedirectUrl,) => {

        const redirectUrl = RedirectUrl

        const returnUrl = WEBROOT + 'mon-profile/passer-owner-validation'

        // Encoder l'URL de retour
        const encodedReturnUrl = encodeURIComponent(returnUrl);

        // Construire l'URL finale
        const finalUrl = `${redirectUrl}&returnUrl=${encodedReturnUrl}`;

        // Rediriger l'utilisateur
        window.location.href = finalUrl;

    }

    useEffect(() => {

        Func.session(context, navigate)

        Func.getFlash(setFlash)

        userPaiements()

        document.title = "Passer Owner - " + APP_NAME

    }, [])

    return (

        <div>

            <Header />

            <div className="profil">

                <HeaderBox />

                <div className='content pos-r'>

                    <div className="c">

                        <HeaderProfile />

                    </div>

                    <div className="mt30">

                        <div className="c pos-r">

                            <ProfileMenu data="porte-monnaie" />

                            {(flash !== '') && <p className={flash.type}>{flash.message}</p>}

                            {

                                data == false

                                    ?

                                    <div className='flex jc-center mt50 mb50'>
                                        <div className="lds-dual-ring col"></div>
                                    </div>

                                    :

                                    <form method='POST' className='gla-form bg6 p20 br10 mb20' onSubmit={(e) => sendData(e)} id='parametres'>

                                        <h3 className='mb30 fw3'>Informations obligatoires</h3>

                                        <p>Cette étape est nécessaire pour vendre et/ou proposer un services sur Sisters Green</p>

                                        <label className='col-5 mt30'>
                                            <span>Date de naissance *</span>
                                            <div><input type='date' name='date' required={true} style={{ border: '1px solid #666', width: '300px' }} /></div>
                                        </label>

                                        <div className="ta-end">
                                            <input type="submit" name="submit" value="Enregistrer" className="btn cl1 bg4 brc4 brc2solid fw5" />
                                        </div>

                                    </form>

                            }

                        </div>
                    </div>
                </div>

            </div>

            <Footer />

        </div>

    )

}

export default PasserOwner